<ng-container *ngIf="!busy, else loadingState">
  <div class="ion-padding flex" *ngIf="issuePositionLocked">
    <ion-chip color="warning" class="flex-col p-4 w-full" id="open-issue-details">
      <ion-label class="text-lg mr-auto flex items-center"><ion-icon name="warning" color="warning" class="mr-2"></ion-icon>{{ issue.attributes.name }}</ion-label>
      <ion-label class="mr-auto mt-4">{{ 'ISSUE.BLOCKED_AMOUNT' | transloco }}</ion-label>
      <ion-label class="mr-auto text-4xl mt-1">
        {{ (+issuePositionLocked.amountUsd * +issuePositionLocked.fiatHistory.value)  | currency : 'EUR' : 'symbol-narrow'}}
        <ion-label class="text-base opacity-50" color="medium">{{ issuePositionLocked.amountUsd  | currency : 'USD' : 'symbol-narrow'}}</ion-label>
      </ion-label>
      <ion-label class="mt-4">{{ issue.attributes.clientImpactMessage }}</ion-label>
      <div class="my-4 h-px w-full bg-gray-300/20"></div>
      <ion-label class="text-base ml-auto font-bold">{{ 'ISSUE.MORE_INFO' | transloco }}</ion-label>
    </ion-chip>
  </div>
</ng-container>
<ng-template #loadingState>
  <div class="ion-padding flex">
    <ion-chip color="warning" class="flex-col p-4 w-full">
      <div class="flex items-center w-full mb-3">
        <ion-skeleton-text animated class="w-6 h-6 rounded-full"></ion-skeleton-text>
        <ion-skeleton-text animated class="h-8 w-1/2 ml-3 rounded"></ion-skeleton-text>
      </div>
      <ion-skeleton-text animated class="h-4 mr-auto w-1/3 mt-3 rounded"></ion-skeleton-text>
      <ion-skeleton-text animated class="h-10 mr-auto w-1/2 mt-2 rounded"></ion-skeleton-text>
      <ion-skeleton-text animated class="h-20 w-full mt-2 rounded"></ion-skeleton-text>
      <div class="my-4 h-px w-full bg-gray-300/20"></div>
      <div class="flex justify-end w-full">
        <ion-skeleton-text animated class="h-5 w-1/3 rounded"></ion-skeleton-text>
      </div>
    </ion-chip>
  </div>
</ng-template>

<app-issue-modal
  *ngIf="issuePositionLocked"
  [presentingElement]="presentingElement"
  [trigger]="'open-issue-details'"
  [issueMessage]="issue.attributes.clientImpactMessageDetails"
  [issueTitle]="issue.attributes.name"
  [showTitle]="true"
  [amountBlocked]="issuePositionLocked.amountUsd"
  [fiatExchangeRate]="issuePositionLocked.fiatHistory.value"
  [lockedTokenHistories]="issuePositionLocked.lockedTokenHistories"
/>